<template>
  <CardModule :title="$t('registrations.producers.comission')">
    <v-row>
      <v-col
        cols="12"
        :class="!inputTaxasPacote ? 'mb-n11 mt-n5' : 'mb-n4 mt-n5'"
      >
        <v-checkbox
          v-model="
            $loja_gerenciar.cadastro.comissao_antecipacao.aplicar_taxas_pacote
          "
          :label="$t('registrations.producers.enable-package-fee')"
        >
        </v-checkbox>
      </v-col>
    </v-row>
    <div v-if="inputTaxasPacote">
      <v-row>
        <v-col cols="12">
          <BaseSelect
            :label="$t('registrations.producers.package-fee-type')"
            :placeholder="$t('registrations.producers.select-package-fee-type')"
            hide-details
            no-data-text=""
            item-text="value"
            item-value="key"
            :clearable="false"
            :items="$loja_gerenciar.cadastro.tipoTaxaPacote"
            v-model="
              $loja_gerenciar.cadastro.comissao_antecipacao.tipoTaxaPacote
            "
          />
        </v-col>
        <v-col cols="12" v-if="taxTypePackageIsValue">
          <BaseMoneyField
            :label="$t('registrations.producers.package-fee')"
            placeholder="0,00"
            v-model="$loja_gerenciar.cadastro.comissao_antecipacao.taxaPacote"
            :options="options5"
          ></BaseMoneyField>
        </v-col>
        <v-col cols="12" v-if="taxTypePackageIsPercent">
          <BaseTextField
            tabindex="3"
            :label="$t('registrations.producers.package-fee')"
            placeholder="0"
            hide-details
            type="number"
            suffix="%"
            v-model="$loja_gerenciar.cadastro.comissao_antecipacao.taxaPacote"
          />
        </v-col>
      </v-row>
    </div>
    <v-row>
      <v-col cols="12" class="mb-n8 mt-n2">
        <v-checkbox
          v-model="
            $loja_gerenciar.cadastro.comissao_antecipacao.aplicar_taxas_cortesia
          "
          :label="$t('registrations.producers.enable-courtesy-fee')"
        >
        </v-checkbox>
      </v-col>
      <div v-if="inputTaxasCortesia">
        <v-col cols="12">
          <BaseMoneyField
            :label="$t('registrations.producers.courtesy-fee')"
            placeholder="0,00"
            v-model="$loja_gerenciar.cadastro.comissao_antecipacao.taxaCortesia"
            :options="options5"
          ></BaseMoneyField>
        </v-col>
      </div>
    </v-row>
    <v-row>
      <v-col cols="12" class="mb-n8 mt-n5">
        <v-checkbox
          v-model="
            $loja_gerenciar.cadastro.comissao_antecipacao
              .aplicar_taxas_gratuidade
          "
          :label="$t('registrations.producers.enable-free-fee')"
        >
        </v-checkbox>
      </v-col>
      <div v-if="inputTaxasGratuidade">
        <v-col cols="12">
          <BaseMoneyField
            :label="$t('registrations.producers.free-fee')"
            placeholder="0,00"
            v-model="
              $loja_gerenciar.cadastro.comissao_antecipacao.taxaGratuidade
            "
            :options="options5"
          ></BaseMoneyField>
        </v-col>
      </div>
    </v-row>
    <h1 class="lojas-gerenciar-comissao-antecipacao-subtitle mt-10">
      {{ $t("registrations.producers.observations") }}
    </h1>
    <v-divider></v-divider>
    <v-row class="mt-5">
      <v-col cols="12">
        <BaseTextarea
          height="140"
          rows="3"
          :label="$t('registrations.producers.negotiation-observations')"
          v-model="$loja_gerenciar.cadastro.comissao_antecipacao.observacoes"
        />
      </v-col>
    </v-row>
  </CardModule>
</template>
<script>
import LojasGerenciarMixins from "@/mixins/Loja-Gerenciar.mixins.js";
import BaseSelect from "@/components/forms/BaseSelect.vue";
import BaseTextField from "@/components/forms/BaseTextField.vue";
import BaseMoneyField from "@/components/forms/BaseMoneyField.vue";
import BaseTextarea from "@/components/forms/BaseTextarea.vue";
export default {
  name: "Comission",
  mixins: [LojasGerenciarMixins],
  components: {
    BaseMoneyField,
    BaseSelect,
    BaseTextField,
    BaseTextarea,
    CardModule: () => import("@/components/cards/CardModule.vue"),
  },
  data() {
    return {
      options5: {
        locale: "pt-BR",
        prefix: "R$",
        suffix: "",
        length: 9,
        precision: 2,
      },
    };
  },
  computed: {
    labelCommissionDisabled() {
      if (
        this.$loja_gerenciar.cadastro.comissao_antecipacao.comissao !==
        "personalizada"
      )
        return true;
      return false;
    },
    labelCommissionStyle() {
      if (
        this.$loja_gerenciar.cadastro.comissao_antecipacao.comissao !==
        "personalizada"
      )
        return "label-disabled";
      return "";
    },
    labelProccessTaxDisabled() {
      if (this.$loja_gerenciar.cadastro.comissao_antecipacao.onProcessamento)
        return true;
      return false;
    },
    inputTaxasPacote() {
      if (
        this.$loja_gerenciar.cadastro.comissao_antecipacao.aplicar_taxas_pacote
      )
        return true;
      return false;
    },
    inputTaxasCortesia() {
      if (
        this.$loja_gerenciar.cadastro.comissao_antecipacao
          .aplicar_taxas_cortesia
      )
        return true;
      return false;
    },
    inputTaxasGratuidade() {
      if (
        this.$loja_gerenciar.cadastro.comissao_antecipacao
          .aplicar_taxas_gratuidade
      )
        return true;
      return false;
    },
    // taxIsTypeCommission() {
    //   if (
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.tipoComissaoWeb ===
    //     "COMISSAO"
    //   )
    //     return true;
    //   return false;
    // },
    // taxIsTypeConvenience() {
    //   if (
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.tipoComissaoWeb ===
    //     "CONVENIENCIA"
    //   )
    //     return true;
    //   return false;
    // },
    taxTypePackageIsValue() {
      if (
        this.$loja_gerenciar.cadastro.comissao_antecipacao.tipoTaxaPacote ===
        "VALOR"
      )
        return true;
      return false;
    },
    taxTypePackageIsPercent() {
      if (
        this.$loja_gerenciar.cadastro.comissao_antecipacao.tipoTaxaPacote ===
        "PERCENTUAL"
      )
        return true;
      return false;
    },
    // taxTypeWebIsValues() {
    //   if (
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.tipoTaxaWeb ===
    //     "VALOR"
    //   )
    //     return true;
    //   return false;
    // },
    // taxTypeWebIsPercent() {
    //   if (
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.tipoTaxaWeb ===
    //     "PERCENTUAL"
    //   )
    //     return true;
    //   return false;
    // },
    // taxTypePosIsValues() {
    //   if (
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.tipoTaxaPos ===
    //     "VALOR"
    //   )
    //     return true;
    //   return false;
    // },
    // taxTypePosIsPercent() {
    //   if (
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.tipoTaxaPos ===
    //     "PERCENTUAL"
    //   )
    //     return true;
    //   return false;
    // },
    processamentoCheck() {
      if (
        this.$loja_gerenciar.cadastro.comissao_antecipacao.taxa_processamento >
        0
      )
        return true;
      return false;
    },
  },
  watch: {
    // "$loja_gerenciar.cadastro.comissao_antecipacao.tipoTaxaWeb"(e) {
    //   if (e === "VALOR") {
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.valor_taxa_web = "0";
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.percentual_taxa_web =
    //       "0";
    //   } else {
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.percentual_taxa_web =
    //       "10";
    //     this.$loja_gerenciar.cadastro.comissao_antecipacao.valor_taxa_web = "0";
    //   }
    // },
    "$loja_gerenciar.cadastro.comissao_antecipacao.onProcessamento"(value) {
      if (!value) {
        this.$loja_gerenciar.cadastro.comissao_antecipacao.taxa_processamento =
          "0";
      }
    },
    "$loja_gerenciar.cadastro.comissao_antecipacao.taxa_processamento"(value) {
      if (value > 0) {
        this.$loja_gerenciar.cadastro.comissao_antecipacao.onProcessamento = true;
      }
    },
    "$loja_gerenciar.cadastro.comissao_antecipacao.aplicar_taxas_pacote"(
      value
    ) {
      if (!value) {
        this.$loja_gerenciar.cadastro.comissao_antecipacao.taxaPacote = "";
      }
    },
    "$loja_gerenciar.cadastro.comissao_antecipacao.aplicar_taxas_cortesia"(
      value
    ) {
      if (!value) {
        this.$loja_gerenciar.cadastro.comissao_antecipacao.taxaCortesia = "";
      }
    },
    "$loja_gerenciar.cadastro.comissao_antecipacao.aplicar_taxas_gratuidade"(
      value
    ) {
      if (!value) {
        this.$loja_gerenciar.cadastro.comissao_antecipacao.taxaGratuidade = "";
      }
    },
  },
  mounted() {
    this.$loja_gerenciar.cadastro.comissao_antecipacao.onProcessamento =
      this.processamentoCheck;
  },
};
</script>
<style scoped>
.lojas-gerenciar-comissao-antecipacao-subtitle {
  width: 487px;
  font-size: 1rem;
  align-self: flex-start;
  margin-top: 1.25rem;
}

.lojas-gerenciar-comissao-antecipacao {
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: column;
}
</style>
